var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.779,
    height: 36.579,
    viewBox: "0 0 31.779 36.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M19.059.03c2-.03,3.978-.015,5.959-.03a9.493,9.493,0,0,0,2.667,6.355,10.748,10.748,0,0,0,6.462,2.728v6.142a16.313,16.313,0,0,1-6.4-1.478,18.83,18.83,0,0,1-2.469-1.417c-.015,4.45.015,8.9-.03,13.336a11.641,11.641,0,0,1-2.058,6,11.355,11.355,0,0,1-9.007,4.892,11.113,11.113,0,0,1-6.218-1.57,11.493,11.493,0,0,1-5.563-8.7c-.03-.762-.046-1.524-.015-2.271A11.474,11.474,0,0,1,15.691,13.839c.03,2.256-.061,4.511-.061,6.767a5.229,5.229,0,0,0-6.676,3.231,6.046,6.046,0,0,0-.213,2.454,5.187,5.187,0,0,0,5.334,4.374A5.12,5.12,0,0,0,18.3,28.211a3.517,3.517,0,0,0,.625-1.616c.152-2.728.091-5.441.107-8.169.015-6.142-.015-12.269.03-18.4Z",
    transform: "translate(-2.369)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.80fdff2b00e35fecc8b51649d87acaef.svg";
export { ForwardRef as ReactComponent };